import {
    getList,
    getItem,
    putItem,
    postItem
} from "./utils/entity-network-requests"

const entityName = "knowledge"

export const getKnowledgeList = (token, parameters) =>
    getList(entityName, parameters, token)
export const getKnowledgeItem = (token, id) => getItem(entityName, id, token)
export const putKnowledgeItem = (token, id, knowledge) =>
    putItem(entityName, id, knowledge, token)

export function postKnowledgeItem(token, data, dataType, shouldPersist, isSimple) {
    const dataToAnalyse = {
        [dataType]: data,
        persist: shouldPersist,
        simple: isSimple
    }
    return postItem(entityName, dataToAnalyse, token)
}
